import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../../utils/analytics';
import { TRUST_ROW } from './homeContent';
import { NYT_FEATURE } from '../../content/nytFeature';
import './HomeTrustRow.css';

/**
 * HomeTrustRow: trust tiles between the Nora film and the FAQ, on BOTH home
 * and /ai-employees (Nitish, Sep 16 2026 01:05-01:45 ET, ruled live off renders
 * in that exact gap; record: Maeve, work/trust_row/).
 *
 * Oct 14 2026 (Nitish): THREE tiles, The New York Times FIRST, then the two
 * Google security tiles. The NYT tile links to the article (new tab); its copy
 * lives in content/nytFeature.js (one source with the header ribbon). Legal
 * (Nora, CEL-3450): text only, no NYT logo or lettering without the Times'
 * written permission; the second line is our own description, never a quote.
 *
 * Shape (his 01:21 ruling): heading, then the line. No small label above the
 * heading (it made "Google" appear twice). The CASA tile shows TAC Security's
 * own ESOF badge above its heading ONLY once `TRUST_ROW.casa.badgeSrc` points at
 * the file TAC delivers (allowed by Nitish Sep 16; requested with the LOV PDF);
 * no placeholder art ever ships. Claims come from org canon `security-claims`
 * (Arjun, Sep 15 2026): dated text, Gmail + Google Analytics scopes on our own
 * client only, never "certified". The two Google tiles link to /security, where
 * the facts live in full; cta_click{trust_tile} carries which tile ('nyt' |
 * 'casa' | 'gmail').
 *
 * @param {string} page - analytics label ('home' | 'ai_employees'); the pages
 *   register `.home-tr` / data-aie-section in their own section_view lists.
 */
const Tile = ({ tile, id, page }) => {
  const track = () => trackEvent('cta_click', { cta_name: 'trust_tile', tile: id, compare_page: page });
  const body = (
    <>
      {tile.badgeSrc ? (
        <img className="home-tr__badge" src={tile.badgeSrc} alt={tile.badgeAlt || ''} loading="lazy" />
      ) : null}
      <span className="home-tr__title">{tile.title}</span>
      <span className="home-tr__line">{tile.line}</span>
    </>
  );
  return tile.href ? (
    <a
      className="home-tr__tile"
      href={tile.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`home-tr-${id}`}
      onClick={track}
    >
      {body}
    </a>
  ) : (
    <Link className="home-tr__tile" to="/security" data-testid={`home-tr-${id}`} onClick={track}>
      {body}
    </Link>
  );
};

const NYT_TILE = { title: NYT_FEATURE.tileTitle, line: NYT_FEATURE.tileLine, href: NYT_FEATURE.url };

const HomeTrustRow = ({ page = 'home' }) => (
  <section className="home-tr" aria-label={TRUST_ROW.aria} data-page={page}>
    <div className="home-tr__inner">
      <Tile tile={NYT_TILE} id="nyt" page={page} />
      <Tile tile={TRUST_ROW.casa} id="casa" page={page} />
      <Tile tile={TRUST_ROW.gmail} id="gmail" page={page} />
    </div>
  </section>
);

export default HomeTrustRow;
